/** `sections/footer.liquid` — `<footer-sticky-bar>`: plays looping background
 *  videos only while the in-flow footer is on screen, and rewinds them when
 *  the footer leaves the viewport. The bar itself is `position: fixed`, so
 *  IntersectionObserver on it would always fire.
 */

class FooterStickyBar extends HTMLElement {
  #observer

  connectedCallback() {
    const videos = [...this.querySelectorAll('video')]
    if (videos.length === 0) return

    const footer = this.previousElementSibling
    const target =
      footer instanceof HTMLElement && footer.classList.contains('site-footer')
        ? footer
        : this

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        videos.forEach((video) => {
          if (entry.isIntersecting && this.#isShown(video)) {
            video.muted = true
            const playPromise = video.play()
            playPromise?.catch?.(() => {})
          } else {
            video.pause()
            try {
              video.currentTime = 0
            } catch {
              // Some browsers throw if metadata isn't loaded yet — safe to ignore.
            }
          }
        })
      },
      { threshold: 0 }
    )

    this.#observer.observe(target)
  }

  disconnectedCallback() {
    this.#observer?.disconnect()
  }

  #isShown(el) {
    if (typeof el.checkVisibility === 'function') return el.checkVisibility()
    return el.getClientRects().length > 0
  }
}

if (!customElements.get('footer-sticky-bar')) {
  customElements.define('footer-sticky-bar', FooterStickyBar)
}
